import { useNavigate } from 'react-router-dom';

export const useHeaderHandlers = ({
  setUrl,
  fetchYoutubeTitle,
  drawerOpen,
  setDrawerOpen,
  loading,
  handleAnalyze,
  handleLogout,
  setLoginDialogOpen,
  setLogoutDialogOpen,
  setProfileAnchorEl,
  setProfileManageModalOpen
}) => {
  const navigate = useNavigate();

  // URL 변경 핸들러
  const handleUrlChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
    if (newUrl.trim()) {
      fetchYoutubeTitle(newUrl);
    }
  };

  // 제목 클리어 핸들러
  const handleClearTitle = () => {
    setUrl("");
    fetchYoutubeTitle("");
    if (drawerOpen) setDrawerOpen(false);
  };

  // 분석 클릭 핸들러
  const handleAnalyzeClick = () => {
    // ✅ 중복 클릭 방지
    if (loading) {
      console.log('🚫 [Header] 이미 분석 중이므로 클릭 무시');
      return;
    }
    handleAnalyze();
    if (drawerOpen) setDrawerOpen(false);
  };

  // 로그아웃 클릭 핸들러
  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
    if (drawerOpen) setDrawerOpen(false);
  };

  // 로그아웃 확인 핸들러
  const handleLogoutConfirm = async () => {
    const success = await handleLogout();
    if (success) {
      navigate('/');
    }
    setLogoutDialogOpen(false);
  };

  // 로그인 클릭 핸들러
  const handleLoginClick = () => {
    setLoginDialogOpen(true);
    if (drawerOpen) setDrawerOpen(false);
  };

  // 로고 클릭 핸들러
  const handleLogoClick = () => {
    if (drawerOpen) setDrawerOpen(false);
    navigate('/');
  };

  // 프로필 클릭 핸들러
  const handleProfileClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
    if (drawerOpen) setDrawerOpen(false);
  };

  // 프로필 메뉴 닫기 핸들러
  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  // 프로필에서 로그아웃 핸들러
  const handleProfileLogout = () => {
    setProfileAnchorEl(null);
    setLogoutDialogOpen(true);
  };

  // 드로어 토글 핸들러
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  // 프로필 관리 모달 핸들러
  const handleProfileManage = () => {
    setProfileAnchorEl(null);
    setProfileManageModalOpen(true);
  };

  const handleProfileManageClose = () => {
    setProfileManageModalOpen(false);
  };

  const handleProfileSave = async (profileData) => {
    // TODO: 프로필 저장 로직 구현
    console.log('프로필 저장:', profileData);
  };

  const handlePasswordChange = async (passwordData) => {
    // TODO: 실제 비밀번호 변경 API 호출 구현
    console.log('비밀번호 변경:', passwordData);
    // 성공 시 메시지 표시 등의 로직 추가
  };

  const handleAccountDelete = () => {
    // TODO: 회원탈퇴 로직 구현
    console.log('회원탈퇴');
  };

  return {
    handleUrlChange,
    handleClearTitle,
    handleAnalyzeClick,
    handleLogoutClick,
    handleLogoutConfirm,
    handleLoginClick,
    handleLogoClick,
    handleProfileClick,
    handleProfileClose,
    handleProfileLogout,
    handleDrawerToggle,
    handleProfileManage,
    handleProfileManageClose,
    handleProfileSave,
    handlePasswordChange,
    handleAccountDelete
  };
}; 